var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 23,
    viewBox: "0 0 29 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.444 9.4c-.194.189-.459.297-.737.297-1.028 0-1.863.81-1.863 1.796 0 .993.825 1.8 1.844 1.81.574.005 1.062.394 1.062.952v3.464c0 2.916-2.433 5.281-5.436 5.281h-4.532a.836.836 0 0 1-.848-.824V19.26c0-.567-.459-1.013-1.043-1.013-.57 0-1.042.446-1.042 1.013v2.917c0 .455-.38.824-.847.824H5.436C2.446 23 0 20.637 0 17.72v-3.465c0-.558.488-.947 1.062-.952 1.02-.01 1.844-.817 1.844-1.81 0-.959-.807-1.688-1.863-1.688-.278 0-.543-.108-.737-.297A.998.998 0 0 1 0 8.792V5.294C0 2.382 2.452 0 5.45 0h9.552c.467 0 .847.369.847.824V4.28c0 .554.472 1.013 1.042 1.013.584 0 1.043-.459 1.043-1.013V.824c0-.455.38-.824.848-.824h4.532c3.003 0 5.436 2.363 5.436 5.28v3.404c0 .27-.111.527-.306.716zm-11.553 6.226c.584 0 1.043-.46 1.043-1.013V9.211c0-.554-.459-1.013-1.043-1.013-.57 0-1.042.46-1.042 1.013v5.402c0 .554.472 1.013 1.042 1.013z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 8.456,
    y1: 4.397,
    x2: 22.77,
    y2: 22.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48AFCC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.db81fb4a8f6714f34546c552e90b4d91.svg";
export { ForwardRef as ReactComponent };